const FieldQuickMessage = (props) => null;

export default FieldQuickMessage;
